import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { getFullVehicleReport } from '../api/vehicleAPI';
import Loader from '../components/common/Loader';
import {
  FaCar, FaFingerprint, FaUser, FaInfoCircle,
  FaFileContract, FaGavel, FaTag, FaHistory,
  FaFilePdf, FaEnvelope, FaSearch, FaShareAlt,
  FaPaperPlane, FaLock
} from 'react-icons/fa';
import { aplicarRegrasCampo } from '../utils/regrasCampos';
import LockedValue from '../components/consulta/LockedValue';


// --- Constantes e Dados de Seção (movido para fora do componente para melhor performance) ---
const SECTIONS = [
  {
      key: 'CONSULTA_COMPLETA',
  title: 'Informações Principais',
  icon: <FaCar />,
  fields: [

    { id: 'placa', label: 'Placa' },
    { id: 'placa_modelo_antigo', label: 'Placa Modelo Antigo' }, // ou 'placa_alternativa'
    { id: 'marca', label: 'Marca' }, // ou 'MARCA'
    { id: 'chassi', label: 'Chassi' },
    { id: 'versao', label: 'Versão' },
    { id: 'modelo', label: 'Modelo' }, // ou 'MODELO'
    { id: 'cor', label: 'Cor' },
    { id: 'ano_modelo', label: 'Ano/Modelo' }, // ou 'anoModelo'
    { id: 'ano_fabricacao', label: 'Ano/Fabricação' }, // ou 'ano'
    { id: 'combustivel', label: 'Combustível' },
    { id: 'segmento', label: 'Segmento' },
    { id: 'municipio', label: 'Município' },
    { id: 'quantidade_passageiro', label: 'Quantidade Passageiros' },
    { id: 'uf', label: 'UF' }, // ou 'uf_placa'
    { id: 'municipio', label: 'Município' },
    { id: 'cilindradas', label: 'Cilindradas' },
    { id: 'motor', label: 'Motor' }, // substituto para 'potencia'
    { id: 'potencia', label: 'Potência' }, // substituto para 'potencia'
    { id: 'nacionalidade', label: 'Nacionalidade' },
    { id: 'tipo_veiculo', label: 'Tipo de Veículo' },
    { id: 'tipo_montagem', label: 'Tipo de Montagem' },
    {
      id: 'restricoes',
      label: 'Restrições',
      type: 'danger',
      format: (val, all) => {
        const lista = [
          all.restricao_1,
          all.restricao_2,
          all.restricao_3,
          all.restricao_4
        ]
          .filter(v => v && v !== 'SEM RESTRICAO' && v !== 'Sem Registro Público');

        return lista.length > 0 ? lista.join(' / ') : 'Sem Restrições';
      }
    },
    { id: 'peso_bruto_total', label: 'Peso Bruto Total' },
    { id: 'cap_maxima_tracao', label: 'Capacidade Máxima de Tração' },
    { id: 'tipo_doc_prop', label: 'Tipo de Pessoa' },
    { id: 'uf_faturado', label: 'UF Faturado' },
    { id: 'situacao_veiculo', label: 'Situação do Veículo' },
    { id: 'situacao_chassi', label: 'Situação do Chassi' }
  ]
},
  {
    key: 'BINESTADUAL',
    title: 'Binário Estadual',
    icon: <FaFingerprint />,
    fields: [

            // { title: 'Identificação do Veículo' },

      { id: 'placa', label: 'Placa' },
      { id: 'chassi', label: 'Chassi' },
      { id: 'numeroMotor', label: 'Número do Motor' },
      { id: 'renavam', label: 'RENAVAM' },
            // { title: 'Descrição Técnica' },

      { id: 'marcaModelo', label: 'Marca / Modelo' },
      { id: 'marca', label: 'Marca' },
      { id: 'modelo', label: 'Modelo' },
      { id: 'cor', label: 'Cor' },
      { id: 'combustivel', label: 'Combustível' },
      { id: 'categoria', label: 'Categoria' },
      { id: 'especie', label: 'Espécie' },
      { id: 'capacidadePassageiros', label: 'Capacidade de Passageiros' },
      { id: 'cilindradas', label: 'Cilindradas' },
            // { title: 'Ficha Técnica' },

      { id: 'tipo', label: 'Tipo' },
      { id: 'tipoCarroceria', label: 'Tipo de Carroceria' },
      { id: 'numeroEixos', label: 'Número de Eixos' },
      { id: 'pesoBrutoTotal', label: 'Peso Bruto Total' },
      { id: 'potencia', label: 'Potência' },
      { id: 'maximaTracao', label: 'Cap. Máxima de Tração' },
            // { title: 'Situação / Movimentação' },

      { id: 'procedencia', label: 'Procedência' },
      { id: 'situacao', label: 'Situação' },
      { id: 'situacaoChassi', label: 'Situação do Chassi' },
      { id: 'documentoFaturado', label: 'Documento Faturado' },
      { id: 'ufFaturada', label: 'UF Faturado' },
      { id: 'municipio', label: 'Município' },
      { id: 'uf', label: 'UF' },
      { id: 'crvCrlvDataEmissao', label: 'Data do CRV/CRLV' },
      { id: 'dataLicenciamento', label: 'Data de Licenciamento' },
      { id: 'ultimaAtualizacao', label: 'Última Atualização' },
      { id: 'proprietarioAtual', label: 'Proprietário Atual' },
      { id: 'documentoProprietarioAtual', label: 'Documento Proprietário Atual' },
      { id: 'proprietarioAnterior', label: 'Proprietário Anterior' },
            // { title: 'Comunicação de Venda' },

      { id: 'status', label: 'Status Comunicação de Venda' },
      { id: 'data', label: 'Data da Venda' },
      { id: 'protocoloDetran', label: 'Protocolo Detran' },
      { id: 'documentoComprador', label: 'Documento do Comprador' },
            // { title: 'Gravame' },

      { id: 'dataInclusao', label: 'Data Inclusão Gravame' },
      { id: 'agenteFinanceiro', label: 'Agente Financeiro' },
      { id: 'documentoFinanciado', label: 'Documento Financiado' },
      { id: 'nomeFinanciado', label: 'Nome Financiado' },
      { id: 'restricaoFinanceira', label: 'Restrição Financeira' },
            // { title: 'Débitos Pendentes' },

      { id: 'ipva', label: 'Valor IPVA' },
      { id: 'dpvat', label: 'Valor DPVAT' },
      { id: 'multas', label: 'Valor de Multas' },
      { id: 'licenciamento', label: 'Valor de Licenciamento' },
            // { title: 'Restrições' },

      { id: 'bloqueiosRenajud', label: 'Restrições SP - Renajud' },
      { id: 'inspecaoambiental', label: 'Restrições SP - Ambiental' },
      { id: 'administrativa', label: 'Restrições SP - Administrativa' },
      { id: 'furto', label: 'Restrições SP - Furto' },
      { id: 'judicial', label: 'Restrições SP - Judicial' },
      { id: 'tributaria', label: 'Restrições SP - Tributária' },
      { id: 'outrasUFs', label: 'Restrições Outras UFs' }
    ]
  },
  {
    key: 'BINFEDERAL',
    title: 'Identificação',
    icon: <FaFingerprint />,
    fields: [
      // { title: 'Identificação do Veículo' },

      { id: 'placa', label: 'Placa' },
      { id: 'chassi', label: 'Chassi' },
      { id: 'numeroMotor', label: 'Número do Motor' },
      { id: 'renavam', label: 'RENAVAM' },
      // { title: 'Descrição Técnica' },

      { id: 'marcaModelo', label: 'Marca / Modelo' },
      { id: 'marca', label: 'Marca' },
      { id: 'modelo', label: 'Modelo' },
      { id: 'cor', label: 'Cor' },
      { id: 'combustivel', label: 'Combustível' },
      { id: 'categoria', label: 'Categoria' },
      { id: 'especie', label: 'Espécie' },
      { id: 'capacidadePassageiros', label: 'Capacidade de Passageiros' },
      { id: 'cilindradas', label: 'Cilindradas' },
            // { title: 'Ficha Técnica' },

      { id: 'tipo', label: 'Tipo' },
      { id: 'tipoCarroceria', label: 'Tipo de Carroceria' },
      { id: 'numeroEixos', label: 'Número de Eixos' },
      { id: 'pesoBrutoTotal', label: 'Peso Bruto Total' },
      { id: 'potencia', label: 'Potência' },
      { id: 'maximaTracao', label: 'Cap. Máxima de Tração' },
            // { title: 'Situação / Movimentação' },

      { id: 'documentoFaturado', label: 'Documento Faturado' },
      { id: 'procedencia', label: 'Procedência' },
      { id: 'ufFaturada', label: 'UF Faturado' },
      { id: 'municipio', label: 'Município' },
                  // { title: 'Situação / Movimentação' },
      { id: 'dataInclusao', label: 'Data Inclusão Gravame' },
      { id: 'agenteFinanceiro', label: 'Agente Financeiro' },
      { id: 'documentoFinanciado', label: 'Documento Financiado' },
      { id: 'nomeFinanciado', label: 'Nome Financiado' },
      { id: 'situacaoChassi', label: 'Situação do Chassi' },
      { id: 'uf', label: 'UF' },
      { id: 'nomeFinanciado', label: 'Nome Financiado' },
      { id: 'restricaoFinanceira', label: 'Restrição Financeira' },
      
    //   { id: 'crvCrlvDataEmissao', label: 'Data do CRV/CRLV' },
    //   { id: 'dataLicenciamento', label: 'Data de Licenciamento' },
    //   { id: 'ultimaAtualizacao', label: 'Última Atualização' },
    //   { id: 'proprietarioAtual', label: 'Proprietário Atual' },
    //   { id: 'documentoProprietarioAtual', label: 'Documento Proprietário Atual' },
    //   { id: 'proprietarioAnterior', label: 'Proprietário Anterior' },
    //   { id: 'status', label: 'Status Comunicação de Venda' },
    //   { id: 'data', label: 'Data da Venda' },
    //   { id: 'protocoloDetran', label: 'Protocolo Detran' },
    //   { id: 'documentoComprador', label: 'Documento do Comprador' },
    //  { id: 'ipva', label: 'Valor IPVA' },
    //   { id: 'dpvat', label: 'Valor DPVAT' },
    //   { id: 'multas', label: 'Valor de Multas' },
    //   { id: 'licenciamento', label: 'Valor de Licenciamento' },
    //   { id: 'bloqueiosRenajud', label: 'Restrições SP - Renajud' },
    //   { id: 'inspecaoambiental', label: 'Restrições SP - Ambiental' },
    //   { id: 'administrativa', label: 'Restrições SP - Administrativa' },
    //   { id: 'furto', label: 'Restrições SP - Furto' },
    //   { id: 'judicial', label: 'Restrições SP - Judicial' },
    //   { id: 'tributaria', label: 'Restrições SP - Tributária' },
    //   { id: 'outrasUFs', label: 'Restrições Outras UFs' }
    ]
  },
  {
    key: 'BINFEDERALRF',
    title: 'Proprietário',
    icon: <FaUser />,
    fields: [
      // { title: 'Identificação do Proprietário' },
    { id: 'placa', label: 'Placa' },
    { id: 'chassi', label: 'Chassi' },
    { id: 'numeroMotor', label: 'Número do Motor' },
    { id: 'renavam', label: 'RENAVAM' },
          // { title: 'Descrição Técnica' },
    { id: 'marcaModelo', label: 'Marca / Modelo' },
    { id: 'anoFabricacao', label: 'Ano de Fabricação' },
    { id: 'anoModelo', label: 'Ano do Modelo' },
    { id: 'capacidadePassageiros', label: 'Capacidade de Passageiros' },
    { id: 'cilindradas', label: 'Cilindradas' },
    { id: 'combustivel', label: 'Combustível' },
    { id: 'cor', label: 'Cor' },
          // { title: 'Ficha Técnica' },

    { id: 'tipo', label: 'Tipo de Veículo' },
    { id: 'numeroEixos', label: 'Número de Eixos' },
    { id: 'peso_bruto_total', label: 'Peso Bruto Total' },
    { id: 'potencia', label: 'Potência' },
    { id: 'maximaTracao', label: 'Capacidade Máxima de Tração' },
          // { title: 'Situação / Movimentação' },

    
    { id: 'cor', label: 'Cor' },
    { id: 'documentoFaturado', label: 'Documento Faturado' },
    { id: 'remarcacaoChassi', label: 'Remarcação do Chassi' },
    { id: 'ufFaturada', label: 'UF Faturada' },
    { id: 'ultimaAtualizacao', label: 'Última Atualização' },
              // { title: 'Histórico de Roubo e Furto' },

    { id: 'especie', label: 'Espécie' },
    { id: 'finalidade', label: 'Finalidade' },
    { id: 'funcionalidade', label: 'Funcionalidade' },
    { id: 'idFinalidade', label: 'ID Finalidade' },
    { id: 'marcaModelo', label: 'Marca/Modelo' },
    { id: 'municipio', label: 'Município' },
    { id: 'numeroMotor', label: 'Número do Motor' },
    { id: 'potencia', label: 'Potência' },
    { id: 'procedencia', label: 'Procedência' },
    { id: 'produto', label: 'Produto' },
    { id: 'proprietarioAtual', label: 'Proprietário Atual' },
    { id: 'remarcacaoChassi', label: 'Remarcação do Chassi' },
    { id: 'renavam', label: 'Renavam' },
    { id: 'restricoes', label: 'Restrições', type: 'danger' },
    { id: 'uf', label: 'UF' },

    ]
  },
  {
    key: 'DECODIFICADORCHASSI',
    title: 'Outras Informações',
    icon: <FaInfoCircle />,
    fields: [
          { id: 'placa', label: 'Placa' },

    { id: 'anoFabricacao', label: 'Ano de Fabricação' },
    { id: 'anoModelo', label: 'Ano do Modelo' },
    { id: 'chassi', label: 'Chassi' },
    { id: 'codigo', label: 'Código' },
    { id: 'combustivel', label: 'Combustível' },
    { id: 'digitoVerificador', label: 'Dígito Verificador', type: 'highlight' },
    { id: 'fabricante', label: 'Fabricante' },
    { id: 'finalidade', label: 'Finalidade' },
    { id: 'funcionalidade', label: 'Funcionalidade' },
    { id: 'idFinalidade', label: 'ID Finalidade' },
    { id: 'localFabricacao', label: 'Local de Fabricação' },
    { id: 'modelo', label: 'Modelo' },
    { id: 'motor', label: 'Motor' },
    { id: 'numeroPortas', label: 'Número de Portas' },
    { id: 'paisOrigem', label: 'País de Origem' },
    { id: 'precoFipe', label: 'Preço FIPE' },
    { id: 'produto', label: 'Produto' },
    { id: 'regiaoGeografica', label: 'Região Geográfica' },
    { id: 'tipoCarroceria', label: 'Tipo de Carroceria' },
    { id: 'tracao', label: 'Tração' },
    { id: 'transmissao', label: 'Transmissão' },
    { id: 'verificacaoSerial', label: 'Verificação Serial', type: 'highlight' }
    ]
  },
  {
    key: 'GRAVAME',
    title: 'Gravame',
    icon: <FaFileContract />,
    fields: [
      { id: 'agenteFinanceiro', label: 'Agente Financeiro' },
    { id: 'alerta', label: 'Alerta', type: 'warning' },
    { id: 'anoModelo', label: 'Ano do Modelo' },
    { id: 'chassi', label: 'Chassi' },
    { id: 'dataInclusao', label: 'Data de Inclusão' },
    { id: 'documentoFinanciado', label: 'Documento do Financiado' },
    { id: 'finalidade', label: 'Finalidade' },
    { id: 'funcionalidade', label: 'Funcionalidade' },
    { id: 'idFinalidade', label: 'ID Finalidade' },
    { id: 'nomeFinanciado', label: 'Nome do Financiado' },
    { id: 'numero', label: 'Número do Gravame' },
    { id: 'placa', label: 'Placa' },
    { id: 'produto', label: 'Produto' },
    { id: 'renavam', label: 'Renavam' },
    { id: 'restricaoFinanceira', label: 'Restrição Financeira', type: 'danger' },
    { 
      id: 'status', 
      label: 'Status do Gravame', 
      type: 'highlight' 
    },
    { id: 'ufGravame', label: 'UF do Gravame' },
    { id: 'ufPlaca', label: 'UF da Placa' }
    ]
  },
  {
    key: 'HISTORICOLEILAO',
    title: 'Histórico de Leilão',
    icon: <FaGavel />,
    fields: [
                  // { title: 'Identificação do Veículo' },

    { id: 'placa', label: 'Placa' },
    { id: 'chassi', label: 'Chassi' },
    { id: 'numeroMotor', label: 'Número do Motor' },
                  // { title: 'Identificação do Veículo' },
    { id: 'subsegmento', label: 'Subsegmento' },
    { id: 'anoFabricacao', label: 'Ano de Fabricação' },
    { id: 'anoModelo', label: 'Ano do Modelo' },
    { id: 'cor', label: 'Cor' },
    { id: 'combustivel', label: 'Combustível' },
    { id: 'marcaModelo', label: 'Marca/Modelo' },
    { id: 'segmento', label: 'Segmento' },
    { id: 'categoria', label: 'Categoria' },
                  // { title: 'Identificação do Veículo' },

    { id: 'finalidade', label: 'Finalidade' },
    { id: 'funcionalidade', label: 'Funcionalidade' },
    { id: 'idFinalidade', label: 'ID Finalidade' },
    { id: 'percentualAceitacao', label: 'Percentual de Aceitação' },
    { id: 'percentualSobTabela', label: 'Percentual sobre Tabela' },
    { id: 'produto', label: 'Produto' },
    { id: 'subsegmento', label: 'Subsegmento' },
    { id: 'chanceVistoriaEspecial', label: 'Chance de Vistoria Especial' }
    ]
  },
  // {
  //   key: 'HISTORICOCPFCNPJ',
  //   title: 'Histórico de Veículos por CPF/CNPJ',
  //   icon: <FaHistory />,
  //   fields: [
  //     { id: 'placa', label: 'Placa' },
  //     { id: 'chassi', label: 'Chassi' },
  //     { id: 'numeroMotor', label: 'Número do Motor' },
  //     { id: 'renavam', label: 'Renavam' },
  //     { id: 'marcaModelo', label: 'Marca/Modelo' },
  //     { id: 'anoFabricacao', label: 'Ano de Fabricação' },
  //     { id: 'anoModelo', label: 'Ano do Modelo' },
  //     { id: 'cor', label: 'Cor' },
  //     { id: 'procedencia', label: 'Procedência' },
  //     { id: 'combustivel', label: 'Combustível' },
  //     { id: 'especie', label: 'Espécie' },
  //     { id: 'cidade', label: 'Cidade' },
  //     { id: 'uf', label: 'UF' }
  //   ]
  // },
  {
    key: 'INDICIOSINISTRO',
    title: 'Indício de Sinistro',
    icon: <FaHistory />,
    fields: [
    { id: 'finalidade', label: 'Finalidade' },
    { id: 'funcionalidade', label: 'Funcionalidade' },
    { id: 'idFinalidade', label: 'ID Finalidade' },
    { 
      id: 'indicioSinistro', 
      label: 'Indício de Sinistro',
      type: 'danger',
      format: (value) => value ? 'POSSUI SINISTRO' : 'SEM INDÍCIO DE SINISTRO'
    },
    { id: 'placa', label: 'Placa' },
    { id: 'produto', label: 'Produto' },
    ]
  },
  {
    key: 'PRECIFICADOR',
    title: 'Tabela FIPE',
    icon: <FaTag />,
    fields: [
                  // { title: 'Informações do Veículo' },
    { id: 'anoModelo', label: 'Ano Modelo', type: 'highlight' },
    { id: 'combustivel', label: 'Combustível' },
    { 
      id: 'marcaModelo', 
      label: 'Marca/Modelo',
      type: 'highlight'
    },
      // { title: 'Tabela FIPE' },
    { id: 'finalidade', label: 'Finalidade' },
    { id: 'funcionalidade', label: 'Funcionalidade' },
    { id: 'idFinalidade', label: 'ID Finalidade' },
    
    { id: 'placa', label: 'Placa' },
    { id: 'produto', label: 'Produto' },
    ]
  },
];

// --- Estilos ---
const PageWrapper = styled.main`
  font-family: 'Manrope', -apple-system, BlinkMacSystemFont, sans-serif;
  line-height: 1.5;
  color: #2D3436;
  background-color: #F8F9FA;
  padding: 0;
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 80px;
`;

const ResultsContainer = styled.div`
  padding: 32px 20px;
`;

const PlacaHeader = styled.div`
  background: linear-gradient(135deg, #6C5CE7 0%, #00CEC9 100%);
  color: white;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

const PlacaHeaderActions = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;

  @media (min-width: 768px) {
    width: auto;
  }
`;

const PlacaDisplay = styled.div`
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 1px;
`;

const ActionButton = styled.button`
  background: white;
  color: #6C5CE7;
  border: none;
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.1);
  font-size: 14px;
  width: 100%;
  justify-content: center;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }
`;

const ResultsSection = styled.div`
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin-bottom: 24px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.1);

  &:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.12);
    transform: translateY(-2px);
  }
`;

const SectionHeader = styled.div`
  background: #F8F9FA;
  padding: 16px 20px;
  border-bottom: 1px solid #DFE6E9;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const SectionTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: #2D3436;
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
`;

const SectionIcon = styled.div`
  color: #6C5CE7;
  font-size: 18px;
  width: 20px;
  text-align: center;
`;

const SectionContent = styled.div`
  padding: 20px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 640px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const InfoItem = styled.div`
  margin-bottom: 12px;
`;

const InfoLabel = styled.div`
  font-size: 13px;
  color: #636E72;
  margin-bottom: 4px;
  font-weight: 500;
`;

const InfoValue = styled.div`
  font-weight: 600;
  padding: 8px 12px;
  background: #F8F9FA;
  border-radius: 8px;
  font-size: 14px;
  width: 100%;
  word-break: break-word;
`;

const HighlightValue = styled(InfoValue)`
  background-color: rgba(0, 206, 201, 0.1);
  border-left: 3px solid #00CEC9;
`;

const WarningValue = styled(InfoValue)`
  background-color: rgba(253, 203, 110, 0.1);
  border-left: 3px solid #FDCB6E;
`;

const DangerValue = styled(InfoValue)`
  background-color: rgba(214, 48, 49, 0.1);
  border-left: 3px solid #D63031;
`;

const LockedSection = styled.div`
  text-align: center;
  padding: 20px;
  color: #636E72;
`;

const LockIcon = styled.div`
  font-size: 24px;
  color: #6C5CE7;
  margin-bottom: 10px;
`;

const UnlockButton = styled.button`
  background: #6C5CE7;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 10px;
  transition: all 0.2s ease;

  &:hover {
    background: #5649C0;
  }
`;

const CtaSection = styled.div`
  background: linear-gradient(135deg, #6C5CE7 0%, #00CEC9 100%);
  color: white;
  padding: 32px 24px;
  border-radius: 16px;
  margin: 32px 0;
  text-align: center;
`;

const CtaTitle = styled.h2`
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 16px;
`;

const CtaSubtitle = styled.p`
  font-size: 15px;
  margin-bottom: 24px;
  opacity: 0.9;
  line-height: 1.6;
`;

const CtaButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
`;

const CtaBtn = styled.a`
  background: white;
  color: #6C5CE7;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 700;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.1);
  font-size: 14px;

  &.secondary {
    background: transparent;
    color: white;
    border: 2px solid rgba(255,255,255,0.3);
  }

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  }
`;

const EmailForm = styled.div`
  background: white;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin-top: 24px;
`;

const FormTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const FormGroup = styled.div`
  margin-bottom: 16px;
`;

const FormInput = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #DFE6E9;
  border-radius: 8px;
  font-family: inherit;
  font-size: 15px;
  transition: all 0.15s ease;

  &:focus {
    outline: none;
    border-color: #A29BFE;
    box-shadow: 0 0 0 3px rgba(108, 92, 231, 0.1);
  }
`;

const FormSubmit = styled.button`
  background: #6C5CE7;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.1);
  font-size: 15px;

  &:hover {
    background: #5649C0;
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  }
`;


// --- Componente ---
const ConsultaCompletaPage = () => {
  const navigate = useNavigate();
  const { orderId, placa } = useParams();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [purchasedProducts, setPurchasedProducts] = useState([]);
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [email, setEmail] = useState('');
  const [confirmEmail, setConfirmEmail] = useState('');
const [openSections, setOpenSections] = useState(() => {
  const initial = {};
  SECTIONS.forEach((s) => {
    initial[s.key] = true; // começa tudo expandido
  });
  return initial;
});

const toggleSection = (key) => {
  setOpenSections((prev) => ({
    ...prev,
    [key]: !prev[key],
  }));
};



  useEffect(() => {
    const fetchReportData = async () => {
  setLoading(true);
  setError(null);
  try {
    const responseData = await getFullVehicleReport({
      placa,
      order_id: orderId
    });
    setReport(responseData.relatorio_agregado);
    setPurchasedProducts(responseData.produtos_comprados);
  } catch (err) {
    console.error("Falha ao carregar dados:", err);
    setError("Não foi possível carregar o relatório. Tente novamente mais tarde.");
  } finally {
    setLoading(false);
  }
};

    if (orderId && placa) {
      fetchReportData();
    }
  }, [orderId, placa]);

  // Função adicionada para corrigir o erro
 const handleUnlockSection = () => {
    navigate(`/pagamento/upsell/${orderId}/${placa}`);
};

  const handleDownloadPdf = () => {
    // Implementar lógica de download PDF
    alert(`Relatório PDF para placa ${placa} será gerado`);
  };

  const handleSendEmail = () => {
    setShowEmailForm(!showEmailForm);
  };

  const handleSubmitEmail = (e) => {
    e.preventDefault();
    if (email !== confirmEmail) {
      alert('Os e-mails digitados não coincidem!');
      return;
    }
    if (!email.includes('@') || !email.includes('.')) {
      alert('Por favor, digite um e-mail válido!');
      return;
    }
    alert(`Relatório enviado com sucesso para: ${email}`);
    setShowEmailForm(false);
    setEmail('');
    setConfirmEmail('');
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: `Relatório Veicular - Placa ${placa}`,
        text: `Confira este relatório completo do veículo de placa ${placa}`,
        url: window.location.href
      }).catch(err => {
        console.log('Erro ao compartilhar:', err);
      });
    } else {
      navigator.clipboard.writeText(window.location.href);
      alert('Link copiado para a área de transferência!');
    }
  };

  const renderValue = (value, type = 'normal') => {
  const ValueComponent =
    type === 'highlight' ? HighlightValue :
    type === 'warning' ? WarningValue :
    type === 'danger' ? DangerValue :
    InfoValue;

  // Exibe sempre o valor como string, mesmo se for vazio, nulo ou undefined
  const displayValue = (value === undefined || value === null || value === '') ? 'Sem Registros' : String(value);

  return <ValueComponent>{displayValue}</ValueComponent>;
};
const aplicarRegrasCampo = (fieldId, value, fullData) => {
  const semRegistro = (val) =>
    val === '' || val === null || val === undefined || val === 'Indeterminado' || val === '0' || val === '-'
      ? 'Sem Registro Público'
      : val;

  switch (fieldId) {
    case 'chassi':
      return value || 'Sem Registro Público';

    case 'marcaModelo':
      return value || `${fullData.marca || ''} / ${fullData.modelo || ''}`;

    case 'marca':
      return fullData.marcaModelo?.split('/')?.[0]?.trim() || 'Sem Registro Público';

    case 'modelo':
      return fullData.marcaModelo?.split('/')?.[1]?.trim() || 'Sem Registro Público';

    case 'chanceVistoriaEspecial':
      return value || 'Sem Registro Público';

    case 'situacao_veiculo':
      return value === 'S' ? 'Ativo' : value === 'N' ? 'Inativo' : semRegistro(value);

    case 'situacao_chassi':
      return value === 'N' ? 'Normal' : value === 'R' ? 'Remarcado' : semRegistro(value);

    default:
      return semRegistro(value);
  }
};


const renderSection = (section) => {
  const sectionData = report?.[section.key];
  const isPurchased = purchasedProducts.includes(section.key);
  const hasData = sectionData && (sectionData.dados || sectionData.json_bruto);
  const isOpen = openSections[section.key];

  return (
    <ResultsSection key={section.key}>
      <SectionHeader onClick={() => toggleSection(section.key)} style={{ cursor: 'pointer' }}>
        <SectionTitle>
          <SectionIcon>{section.icon}</SectionIcon>
          {section.title}
        </SectionTitle>
        <div>{isOpen ? '−' : '+'}</div>
      </SectionHeader>

      {isOpen && (
        <SectionContent>
          {section.fields.map((field, index) => {
            if (field.title) {
              return (
                <InfoItem key={`title-${index}`} style={{ gridColumn: '1 / -1' }}>
                  <h4 style={{ color: '#6C5CE7', marginTop: '12px', fontSize: '15px' }}>{field.title}</h4>
                </InfoItem>
              );
            }

            if (isPurchased && hasData) {
              const sectionContent = sectionData.dados || {};
              const rawValue = sectionContent[field.id] ?? sectionData.json_bruto?.[0]?.[field.id];
              const value = aplicarRegrasCampo(field.id, rawValue, sectionContent);
              const renderedValue = field.format ? field.format(value, sectionContent) : value;

              return (
                <InfoItem key={field.id}>
                  <InfoLabel>{field.label}</InfoLabel>
                  {renderValue(renderedValue, field.type)}
                </InfoItem>
              );
            } else {
              return (
                <InfoItem key={field.id}>
                  <LockedValue label={field.label} onClick={handleUnlockSection} />
                </InfoItem>
              );
            }
          })}
        </SectionContent>
      )}
    </ResultsSection>
  );
};



  if (loading) return <Loader />;
  if (error) return <div>{error}</div>;
  if (!report) return <div>Nenhum dado encontrado para a placa {placa}.</div>;

  return (
    <PageWrapper>
      <ResultsContainer>
        <PlacaHeader>
          <PlacaDisplay>{placa}</PlacaDisplay>
          <PlacaHeaderActions>
            <ActionButton onClick={handleDownloadPdf}>
              <FaFilePdf /> Salvar como PDF
            </ActionButton>
            <ActionButton onClick={handleSendEmail}>
              <FaEnvelope /> Enviar por E-mail
            </ActionButton>
          </PlacaHeaderActions>
        </PlacaHeader>
        
        <CtaSection>
          <CtaTitle>Relatório Completo Gerado</CtaTitle>
          <CtaSubtitle>
            Aqui estão todas as informações disponíveis sobre este veículo. Você pode salvar ou compartilhar este relatório.
          </CtaSubtitle>
          <CtaButtons>
            <CtaBtn href="/">
              <FaSearch /> Nova Consulta
            </CtaBtn>
            <CtaBtn as="button" className="secondary" onClick={handleShare}>
              <FaShareAlt /> Compartilhar
            </CtaBtn>
          </CtaButtons>
        </CtaSection>
        
        {SECTIONS.map(renderSection)}
        
        {showEmailForm && (
          <EmailForm>
            <FormTitle>
              <FaEnvelope /> Enviar relatório por e-mail
            </FormTitle>
            <form onSubmit={handleSubmitEmail}>
              <FormGroup>
                <FormInput
                  type="email"
                  placeholder="Digite seu e-mail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </FormGroup>
              <FormGroup>
                <FormInput
                  type="email"
                  placeholder="Confirme seu e-mail"
                  value={confirmEmail}
                  onChange={(e) => setConfirmEmail(e.target.value)}
                  required
                />
              </FormGroup>
              <FormSubmit type="submit">
                <FaPaperPlane /> Enviar Relatório
              </FormSubmit>
            </form>
          </EmailForm>
        )}
        
        <CtaSection>
          <CtaTitle>Precisa consultar outro veículo?</CtaTitle>
          <CtaSubtitle>
            Realize uma nova consulta para obter informações completas sobre qualquer veículo
          </CtaSubtitle>
          <CtaButtons>
            <CtaBtn href="/">
              <FaSearch /> Nova Consulta
            </CtaBtn>
            <CtaBtn as="button" className="secondary" onClick={handleShare}>
              <FaShareAlt /> Compartilhar
            </CtaBtn>
          </CtaButtons>
        </CtaSection>
      </ResultsContainer>
    </PageWrapper>
  );
};

export default ConsultaCompletaPage;